export const GET_SERVICE_REMINDER_LOG = "GET_SERVICE_REMINDER_LOG";

export const CLEAR_SERVICE_REMINDER_LOG = "CLEAR_SERVICE_REMINDER_LOG";

export const SET_SERVICE_REMINDER_LOG_LOADING_STATUS = 'SET_SERVICE_REMINDER_LOG_LOADING_STATUS'